/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Drop_InsInputs */

const en_admin_dashboard_drop_ins = /** @type {(inputs: Admin_Dashboard_Drop_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-ins`)
};

const de_admin_dashboard_drop_ins = /** @type {(inputs: Admin_Dashboard_Drop_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-ins`)
};

const es_admin_dashboard_drop_ins = /** @type {(inputs: Admin_Dashboard_Drop_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-ins`)
};

const fr_admin_dashboard_drop_ins = /** @type {(inputs: Admin_Dashboard_Drop_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-ins`)
};

const nl_admin_dashboard_drop_ins = /** @type {(inputs: Admin_Dashboard_Drop_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-ins`)
};

const it_admin_dashboard_drop_ins = /** @type {(inputs: Admin_Dashboard_Drop_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-in`)
};

const pt_br2_admin_dashboard_drop_ins = /** @type {(inputs: Admin_Dashboard_Drop_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avulsos`)
};

const pl_admin_dashboard_drop_ins = /** @type {(inputs: Admin_Dashboard_Drop_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-iny`)
};

const hu_admin_dashboard_drop_ins = /** @type {(inputs: Admin_Dashboard_Drop_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alkalmi látogatások`)
};

const ro_admin_dashboard_drop_ins = /** @type {(inputs: Admin_Dashboard_Drop_InsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-in-uri`)
};

/**
* | output |
* | --- |
* | "Drop-ins" |
*
* @param {Admin_Dashboard_Drop_InsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_drop_ins = /** @type {((inputs?: Admin_Dashboard_Drop_InsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Drop_InsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_drop_ins(inputs)
	if (locale === "de") return de_admin_dashboard_drop_ins(inputs)
	if (locale === "es") return es_admin_dashboard_drop_ins(inputs)
	if (locale === "fr") return fr_admin_dashboard_drop_ins(inputs)
	if (locale === "nl") return nl_admin_dashboard_drop_ins(inputs)
	if (locale === "it") return it_admin_dashboard_drop_ins(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_drop_ins(inputs)
	if (locale === "pl") return pl_admin_dashboard_drop_ins(inputs)
	if (locale === "hu") return hu_admin_dashboard_drop_ins(inputs)
	return ro_admin_dashboard_drop_ins(inputs)
});
export { admin_dashboard_drop_ins as "admin.dashboard.drop_ins" }